export class AreaMap {
    constructor() { }

    Id: number;

    Legend: string;
    Comment: string;
    JsonContent: string;
    Picture: File;
    BackgroundPictureElectronicDocumentId: number;
    ElectronicDocumentId: string;
    SamplingElectronicDocumentId: string;
    IsSituationPlan: boolean;
    Version: number;
    LingetteAreaMapId: number;
    MassifAreaMapId: number;
        
    static mapFromJSON(json): AreaMap {
        const z = new AreaMap;

        z.Id = json['id'];
        z.Legend = json['legend'];
        z.IsSituationPlan = json['isSituationPlan'];
        z.Comment = json['comment'];
        z.JsonContent = json['jsonContent'];
        z.BackgroundPictureElectronicDocumentId = json['backgroundPictureElectronicDocumentId'];
        z.ElectronicDocumentId = json['electronicDocumentId'];
        z.SamplingElectronicDocumentId = json['samplingElectronicDocumentId'];
        z.Version = json['version'];
        z.LingetteAreaMapId = json['lingetteAreaMapId'];
        z.MassifAreaMapId = json['massifAreaMapId'];

        return z;
    }
}